<template lang="pug">
.d-program-preview
  transition( name='fade' mode='out-in' appear)
    .inner(
      v-if='program'
      :key='program.id'
    )
</template>

<script lang="js">

export default {
  name: 'ProgramPreviewDisplay',
  mixins: [],
  components: {},
  props: {
    program: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.d-program-preview {
  
}
</style>
